import {UserRepository} from '../../../repositories/user.repository';
import * as Model from '../../../models/models';
import _ = require('lodash');

export class UserService {
    public static $inject = ['userRepository'];

    constructor(private userRepository: UserRepository) {
    }  

    public signUp(signUpRequest : Model.UserSignUpRequest,  recaptchaResponse: string): ng.IPromise<Model.UserSignUpResponse> {
        return this.userRepository.signUp( signUpRequest, recaptchaResponse);
    }
}
